const { SITE_URL, getPage, getBreadcrumbs } = require('./pages')
const showrooms = require('./showrooms.json')

function getStructuredData (page, collectionItems = []) {
  if (!page.path || page.noindex) return null
  const url = SITE_URL + page.path
  const organization = {
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'LITHIUM',
    url: `${SITE_URL}/`,
    email: 'info@lithiumhome.ru',
    telephone: showrooms.find(store => store.id === '01').telephone
  }
  const graph = [organization, {
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: `${SITE_URL}/`,
    name: 'LITHIUM',
    inLanguage: 'ru-RU',
    publisher: { '@id': organization['@id'] }
  }, {
    '@type': page.path === '/contacts' ? 'ContactPage' : collectionItems.length ? 'CollectionPage' : 'WebPage',
    '@id': `${url}#webpage`,
    url,
    name: page.title,
    description: page.description,
    inLanguage: 'ru-RU',
    isPartOf: { '@id': `${SITE_URL}/#website` },
    about: { '@id': organization['@id'] }
  }]
  const breadcrumbs = getBreadcrumbs(page)
  if (breadcrumbs.length) {
    graph[2].breadcrumb = { '@id': `${url}#breadcrumb` }
    graph.push({
      '@type': 'BreadcrumbList',
      '@id': `${url}#breadcrumb`,
      itemListElement: breadcrumbs.map((item, index) => ({ '@type': 'ListItem', position: index + 1, ...item }))
    })
  }
  if (collectionItems.length) {
    const id = `${url}#collection`
    graph[2].mainEntity = { '@id': id }
    graph.push({
      '@type': 'ItemList',
      '@id': id,
      name: page.h1 || page.name,
      numberOfItems: collectionItems.length,
      itemListElement: collectionItems.map((item, index) => {
        const itemPage = getPage(item.link)
        if (!itemPage.path || itemPage.noindex || itemPage.path !== item.link) {
          throw new Error(`Invalid collection URL: ${item.link}`)
        }
        const image = item.image ? new URL(item.image, SITE_URL).href : null
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Thing',
            '@id': SITE_URL + itemPage.path,
            name: item.name,
            url: SITE_URL + itemPage.path,
            ...(image ? { image } : {})
          }
        }
      })
    })
  }
  if (page.path === '/contacts') {
    const stores = showrooms.map(store => ({
      '@type': 'FurnitureStore',
      '@id': `${SITE_URL}/contacts#showroom-${store.id}`,
      url: `${SITE_URL}/contacts`,
      name: store.name,
      telephone: store.telephone,
      email: store.email,
      address: { '@type': 'PostalAddress', addressCountry: 'RU', addressLocality: store.city, streetAddress: store.streetAddress },
      geo: { '@type': 'GeoCoordinates', latitude: store.latitude, longitude: store.longitude },
      openingHoursSpecification: store.hours.map(hours => ({ '@type': 'OpeningHoursSpecification', ...hours })),
      parentOrganization: { '@id': organization['@id'] }
    }))
    graph[2].mainEntity = stores.map(store => ({ '@id': store['@id'] }))
    graph.push(...stores)
  }
  return { '@context': 'https://schema.org', '@graph': graph }
}

function getMetaInfo (path) {
  const page = getPage(path)
  const schema = getStructuredData(page)
  return {
    title: page.title,
    htmlAttrs: { lang: 'ru' },
    meta: [
      { vmid: 'description', name: 'description', content: page.description },
      ...(page.noindex ? [{ vmid: 'robots', name: 'robots', content: 'noindex, nofollow' }] : [])
    ],
    link: page.path && !page.noindex ? [{ vmid: 'canonical', rel: 'canonical', href: SITE_URL + page.path }] : [],
    script: schema ? [{ vmid: 'schema', type: 'application/ld+json', json: schema }] : []
  }
}

function getImageAlt (path, number) {
  const page = getPage(path)
  return page.imageAlt ? `${page.imageAlt}, фото ${number}` : ''
}

function getCollectionMetaInfo (path, items) {
  const schema = getStructuredData(getPage(path), items)
  return { script: schema ? [{ vmid: 'schema', type: 'application/ld+json', json: schema }] : [] }
}

module.exports = { getMetaInfo, getStructuredData, getImageAlt, getCollectionMetaInfo }
